<template>
  <!-- Contact Section start -->
  <section id="contact" class="contact">
    <div class="contact-decor">
      <div class="contact-circle1">
        <img src="../assets/images/main-banner12.png" alt="" />
      </div>
      <div class="contact-circle2">
        <img src="../assets/images/main-banner1.png" alt="" />
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-8 col-sm-12">
          <div class="contact-us">
            <div class="w-100">
              <h2 class="title">
                <span>contact </span>information
              </h2>
              <form id="myform" class="theme-form" method="get">
                <div class="form-group">
                  <div class="row">
                    <div
                      id="mail_alert_class"
                      class="alert alert-success alert-dismissible d-none"
                    >
                      <a
                        href="#"
                        class="close"
                        data-dismiss="alert"
                        aria-label="close"
                        >&times;</a
                      >
                      <div id="alert_mail"></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-6 md-fgrup-margin">
                      <input
                        id="fullname"
                        v-model="name"
                        type="text"
                        class="form-control"
                        name="fullname"
                        placeholder="your name"
                        required="required"
                      />
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <input
                        id="phone"
                        v-model="phone"
                        type="number"
                        class="form-control"
                        name="phone"
                        placeholder="phone"
                        required="required"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <input
                    id="email"
                    v-model="email"
                    type="email"
                    class="form-control"
                    name="email"
                    placeholder="email address"
                    required="required"
                  />
                </div>
                <div class="form-group">
                  <textarea
                    id="message"
                    v-model="message"
                    class="form-control"
                    name="message"
                    rows="4"
                    placeholder="message"
                    required="required"
                  ></textarea>
                </div>
                <!-- SMS Opt-in Checkbox and Disclaimer -->
                <div class="form-group">
                  <input
                    id="smsOptIn"
                    v-model="smsOptIn"
                    type="checkbox"
                    :class="{'is-invalid': smsOptInError}"
                  />
                  <label for="smsOptIn">
                    I agree to receive communication by text message regarding my inquiries or payment reminders from ezfixd.com. I understand that I may opt out at any time by replying STOP or reply HELP for more information. Message frequency varies. Message and data rates may apply. ezfixd.com will not sell or share my data with any third parties. You may review our <a href="/privacy-policy">Privacy Policy</a> to learn how your data is used.
                  </label>
                  <div v-if="smsOptInError" class="invalid-feedback">
                    You must agree to receive SMS messages to submit the form.
                  </div>
                </div>
                <!-- End of SMS Opt-in -->
                <div class="row">
                  <div class="col-sm-12 col-md-6 text-message hide">
                    Message Sent Successfully
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="form-button">
                      <input
                        id="send"
                        type="button"
                        name="send"
                        class="btn btn-custom theme-color"
                        value="send"
                        :disabled="!enableForm()"
                        @click="contact"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-4 d-medium-none-lg">
          <div class="contact-right"></div>
        </div>
      </div>
    </div>
  </section>
  <!-- Contact Section End -->
</template>

<script>
import $ from 'jquery';

export default {
  name: 'ContactUs',
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      message: '',
      smsOptIn: false,
      smsOptInError: false, // New data property for error state
      sent: false,
    };
  },
  methods: {
    contact() {
      if (!this.smsOptIn) {
        this.smsOptInError = true;
        // Optionally, focus on the checkbox
        document.getElementById('smsOptIn').focus();
        return;
      } else {
        this.smsOptInError = false;
      }
      this.axios
        .post(`${process.env.ROOT_API}/contact`, {
          name: this.name,
          phone: this.phone,
          email: this.email,
          message: this.message,
          smsOptIn: this.smsOptIn,
        })
        .then((response) => {
          $('.text-message').removeClass('hide');
          this.sent = true;
        });
    },
    enableForm() {
      return (
        !this.sent &&
        this.name.length &&
        this.phone.length &&
        this.email.length &&
        this.message.length
        // Exclude smsOptIn from enableForm
      );
    },
  },
  watch: {
    smsOptIn(val) {
      if (val) {
        this.smsOptInError = false;
      }
    },
  },
};
</script>

<style scoped>
.hide {
  opacity: 0;
}
.text-message {
  padding-left: 21px;
  color: red;
}
.is-invalid {
  border-color: red;
}
.invalid-feedback {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/contact_us.vue